import * as HttpService from './HttpService'

let namespace = 'calculations'

let find = (id, options, cb, errorCb) => {
    HttpService.get(namespace + '/' + id, options, cb, errorCb)
}

let findAll = (params, cb, errorCb) => {
    HttpService.get(namespace, params, cb, errorCb)
}

let ebitda = (companyId, params, cb, errorCb) => {
    HttpService.get(namespace + '/' + companyId + '/ebitda', params, cb, errorCb)
}

let create = (body, cb, errorCb) => {
    HttpService.post(namespace, body, cb, errorCb)
}

let remove = (id, cb, errorCb) => {
    HttpService.remove(namespace + '/' + id, cb, errorCb)
}

let update = (id, body, cb, errorCb) => {
    HttpService.put(namespace + '/' + id, body, cb, errorCb)
}

let valueChain = (params, cb, errorCb) => {
    HttpService.get(namespace + '/value-chain', params, cb, errorCb)
}

let projectTypesPotential = (params, cb, errorCb) => {
    HttpService.get(namespace + '/potential/project-types', params, cb, errorCb)
}

export {
    find,
    findAll,
    ebitda,
    create,
    remove,
    update,
    valueChain,
    projectTypesPotential
}



// WEBPACK FOOTER //
// ./src/services/calculationService.js